import { ReactNode } from "react";
import "./FullscreenContainer.css";

interface FullscreenContainerProps {
    children: ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export default function FullscreenContainer({
    children,
    className = "",
    style = {},
}: FullscreenContainerProps) {
    return (
        <div className={`fullscreen-container ${className}`} style={style}>
            <div className="fullscreen-content">
                {children}
            </div>
        </div>
    );
}
